export function useLicenseModal() {
  const open = useState<boolean>("license-modal-open", () => false);

  return {
    open,
    show: () => {
      open.value = true;
    },
    hide: () => {
      open.value = false;
    },
  };
}
